import clsx from "clsx";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import {
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";
import { Button, OrFormDivider } from "@transfr-inc/dashboard-components/forms";

import { Role } from "@models/role";
import { useCurrentUser, useRole } from "@queries";

import CreateInstructorModal from "./create-instructor-modal";
import { UserOptionItem } from "./user-option-item";
import { UserSelect } from "./user-select";

export const InstructorsEditor = ({
  data,
  onCreateInstructor,
  creationEnabled = true,
  className,
}) => {
  const currentUser = useCurrentUser();
  const role = useRole();
  const { control, setValue } = useFormContext();
  const [showCreateInstructorModal, setShowCreateInstructorModal] = useState();
  const [successfullyCreatedInstructor, setSuccessfullyCreatedInstructor] =
    useState();

  const onCreateInstructorModalClose = (instructor) => {
    if (!instructor || instructor.canceled) {
      setSuccessfullyCreatedInstructor();
    } else {
      setSuccessfullyCreatedInstructor(instructor);
    }

    setShowCreateInstructorModal(false);
  };

  useEffect(() => {
    const userFound =
      role === Role.INSTRUCTOR.id &&
      data?.find((x) => x.userId == currentUser.userId);
    const defaultInstructor = userFound ? [new UserOptionItem(userFound)] : [];

    setValue("instructors", defaultInstructor);
  }, []);

  return (
    <div className={clsx("add-instructors-editor", className)}>
      {creationEnabled && (
        <>
          {successfullyCreatedInstructor && (
            <Notification
              type={NotificationType.success}
              closable
              onClose={() => {
                setSuccessfullyCreatedInstructor();
              }}
            >
              {successfullyCreatedInstructor.firstName}{" "}
              {successfullyCreatedInstructor.lastName} has been created as an
              instructor.
            </Notification>
          )}
          <div className="create-instructor-button">
            <Button
              primary={false}
              size="small"
              icon={["fa-light", "user-plus"]}
              onClick={() => setShowCreateInstructorModal(true)}
              className="main-dialog"
            >
              Create Instructor
            </Button>
          </div>

          <OrFormDivider />
        </>
      )}

      <Controller
        control={control}
        name="instructors"
        render={({ field: { onChange, value } }) => {
          return (
            <UserSelect
              placeholder={"Add one or more additional instructors..."}
              onChange={onChange}
              data={data}
              selected={value}
            />
          );
        }}
      />
      <CreateInstructorModal
        onCreateInstructor={onCreateInstructor}
        open={showCreateInstructorModal}
        onClose={onCreateInstructorModalClose}
      />
    </div>
  );
};
